import { DEFAULT_PANEL_SETTING } from './helpers'

export default {
    data: [],
    env: 'DEV',
    pagination: 100,
    type: 'key',
    sortMethod: 'alphabet',
    keyword: '',
    searchMethod: 'keyword',
    isLoading: false,
    projects: [],
    project: '',
    ticketVersion: null,
    // {
    //   success: true,
    //   text: 'work',
    //   id: new Date().getTime()
    // }，
    messages: [],
    idModal: 0,
    isModal: false,
    isHistoryMode: false,
    isDeployMode: false,
    isApproveMode: false,
    historyData: [],
    historyPageData: {},
    updatedTickets: [],
    user: null,
    langs: [
      'zh_CN',
      'zh_HK',
      'en_US',
      'ms_MY',
      'id_ID',
      'vi_VN',
      'hi_IN',
      'ja_JP',
      'ko_KR',
      'th_TH',
      'es_ES',
      'pt_PT',
      'en_IN',
      'en_PH',
      'tl_PH',
      'tr_TR',
      'bn_BD',
      'en_NG',
    ],
    langsMapping: {
      zh_CN: '簡體中文',
      zh_HK: '繁體中文',
      en_US: '英文',
      ms_MY: '馬來西亞文',
      id_ID: '印尼文',
      vi_VN: '越南文',
      hi_IN: '印地文',
      ja_JP: '日文',
      ko_KR: '韓文',
      th_TH: '泰文',
      es_ES: '西班牙文',
      pt_PT: '葡萄牙文',
      en_IN: '印度英文',
      en_PH: '菲律賓英文',
      tl_PH: '他加祿語',
      tr_TR: '土耳其文',
      bn_BD: '孟加拉語',
      en_NG: '尼日利亞英文',
    },
    isConfirmApproveModalOpen: false,
    isConfirmDeployModalOpen: false,
    // approvedCards: [],
    cardsHistory: {},
    deployableVersions: [],
    currentVersion: 0,
    devVersion: 0,
    qaVersion: 0,
    updatedTicketsPage: [],
    deployableVersionsPage: [],
    needValidateKey: false,
    panelSetting: { ...DEFAULT_PANEL_SETTING },
  }

